import { AbgSxProps } from '@abg/typings';

export const containerStyling: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  padding: '2px 0 8px',
  width: 'max-content',
  marginBottom: '2px',
};

export const ratingItemStyling: AbgSxProps = {
  width: '15px',
  height: '6px',
  borderRadius: '1px',
  margin: '0 1px',
};
